import { HttpRequestMethodTypes, JSON_CONTENT_TYPE_HEADER } from 'types';
import { fetchWithRetry } from 'utils/fetchWithRetry';
import { FetchOptions } from 'types/fetchWithRetry';

import type { SaveViewedListingsRequestBodyType, GetViewedListingsRequestBodyType, GetViewedListingsResponse } from './types';
import { getThemeByTenantId, TenantId } from '@tenants';
import Listing from 'data/listing';
import { User } from '@bedrock/auth';

export async function captureListingView(listingId: Listing['id'], userId: User['id'], isModal: boolean, tenantId: TenantId, listingSlug?: string) {
  if (!userId) {
    return;
  }
  const body: SaveViewedListingsRequestBodyType = {
    listingId,
    userId,
    isModal,
    authUser: true,
    sourceTheme: getThemeByTenantId(tenantId).id,
    listingSlug: listingSlug || '',
  };

  const options: FetchOptions = {
    headers: JSON_CONTENT_TYPE_HEADER,
    method: HttpRequestMethodTypes.POST,
    body: JSON.stringify(body),
  };

  try {
    const response = await fetchWithRetry('/api/viewed-listings/handler', options);
    const parsedResponse = await response.json();
    if (response.ok) {
      return parsedResponse;
    } else if ('error' in parsedResponse) {
      const { error } = parsedResponse;
      return error?.message ? new Error(error?.message) : new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    const wrappedError = new Error(`There was an error sending the user's viewed listing: ${(error as Error)?.message}`, { cause: error as Error });
    console.error(wrappedError);
    return wrappedError;
  }
}

export async function getUserViewedListings(body: GetViewedListingsRequestBodyType) {
  const options: FetchOptions = {
    headers: JSON_CONTENT_TYPE_HEADER,
    method: HttpRequestMethodTypes.GET,
  };

  try {
    const response = await fetchWithRetry(`/api/viewed-listings/handler/${body.userId}?sourceTheme=${body.sourceTheme}`, options);
    const parsedResponse = await response.json();
    if (response.ok) {
      return parsedResponse as GetViewedListingsResponse;
    } else if ('error' in parsedResponse) {
      const { error } = parsedResponse;
      return error?.message ? new Error(error?.message) : new Error(`Request failed with status ${response.status}`);
    }

  } catch (error) {
    const wrappedError = new Error(`There was an error sending the user's last search: ${(error as Error)?.message}`, { cause: error as Error });
    console.error(wrappedError);
    return wrappedError;
  }
}
